import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faListAlt, faListCheck, faListDots, faListOl, faQrcode, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import './EventFlowHome.css';
import eventflowimage from '../../assets/pageimages/EventFlow.webp';

function EventFlowHome() {
  return (
    <MainLayout>
      <div className="min-h-screen py-8 bg-gradient-to-r from-teal-500 via-green-500 to-blue-500 mt-12">
        <h2 className='text-3xl font-bold text-white text-center'>EventFlow</h2>
        <div className="min-h-[30vh] px-4">
          <div className="flex justify-center mb-2">
            <img src={eventflowimage} alt="MyProfile Image" style={{width: '300px', height:'auto'}} className="rounded-lg shadow-lg max-w-md mt-4 mb-4" />
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 mb-250">
            <CardLink to="/event-flow-eventlist/my" icon={faListDots} text="My Events List" />
            <CardLink to="/event-flow-eventlist/open" icon={faListCheck} text="Open Events List" />
            <CardNoLink to="/event-flow-eventlist/invitation" icon={faListAlt} text="By Invitation Events List" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

// CardLink Component
const CardLink = ({ to, icon, text }) => (
  <div className="bg-white p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <Link to={to} className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </Link>
  </div>
);

const CardNoLink = ({ to, icon, text }) => (
  <div className="bg-gray-500 p-2 rounded-lg shadow-lg transition-transform transform hover:scale-105">
    <p className="flex items-center text-sm sm:text-m text-gray-700 hover:text-gray-900">
      <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
      {text}
    </p>
  </div>
);

export default EventFlowHome;


